import { Usuario } from './../models/Usuario';
import { MethodsEnum } from "../enums/Methods.ts";
import handleService from "./apiService.ts";
import { CatalogoPermissoes, TipoUsuario, UsuarioLogado } from "../types/Permissoes.ts";

const create = async (
  usuario: Usuario & {
    nome?: string;
    tipo?: TipoUsuario;
    podeExcluirAgendamento?: boolean;
    podeVerLog?: boolean;
  }
) => {
  const result = await handleService({
    method: MethodsEnum.POST,
    endpoint: "/usuario",
    data: usuario,
  });
  return result;
};

// O campo senha NAO existe mais neste contrato. Ele era gravado sem nenhuma
// checagem de posse (o id vinha no corpo), entao qualquer usuario autenticado
// trocava a senha de qualquer outro, de qualquer empresa. Troca de senha agora
// so por alterarSenha (exige a atual) ou pelo fluxo de recuperacao por e-mail.
const update = async (dados: {
  id: string;
  telefone?: string;
  nome?: string;
  tipo?: TipoUsuario;
  podeExcluirAgendamento?: boolean;
  podeVerLog?: boolean;
}) => {
  const result = await handleService({
    method: MethodsEnum.PATCH,
    endpoint: "/usuario/alterar",
    data: dados,
  });
  return result;
};

/** Quem sou eu e o que posso fazer. Base do PermissoesContext. */
const meusDados = async (): Promise<UsuarioLogado | null> => {
  const result = await handleService({ endpoint: "/usuario/me" });
  return result?.data ?? null;
};

/**
 * Catalogo de funcoes e do que cada uma libera.
 *
 * Vem do backend, e nao de uma constante aqui, de proposito: e o mesmo catalogo
 * que o servidor usa para autorizar as requisicoes. Uma lista escrita a mao no
 * frontend viraria uma segunda fonte e, na primeira mudanca de regra, a tela
 * passaria a prometer acesso que a API nega.
 */
const catalogoPermissoes = async (): Promise<CatalogoPermissoes | null> => {
  const result = await handleService({ endpoint: "/usuario/funcionalidades" });
  return result?.data ?? null;
};

/** Passo 1 do "esqueci minha senha": dispara o e-mail com o link.
 * O backend responde sempre igual, exista ou nao conta com esse e-mail. */
const solicitarRecuperacaoSenha = async (email: string) => {
  const result = await handleService({
    method: MethodsEnum.POST,
    endpoint: "/usuario/recuperar-senha",
    data: { email },
  });
  return result;
};

/** Passo 2: troca a senha usando o token que veio no link do e-mail. */
const redefinirSenha = async (token: string, senha: string) => {
  const result = await handleService({
    method: MethodsEnum.POST,
    endpoint: "/usuario/redefinir-senha",
    data: { token, senha },
  });
  return result;
};

/** Troca de senha de quem ja esta logado (Configuracoes > Seguranca). */
const alterarSenha = async (senhaAtual: string, novaSenha: string) => {
  const result = await handleService({
    method: MethodsEnum.POST,
    endpoint: "/usuario/alterar-senha",
    data: { senhaAtual, novaSenha },
  });
  return result;
};

const usuarioService = {
  create,
  update,
  meusDados,
  catalogoPermissoes,
  solicitarRecuperacaoSenha,
  redefinirSenha,
  alterarSenha,
};

export default usuarioService;